import React, { useEffect, useState } from "react";
import { Field, buttonClass, fieldClass, errorText } from "./shared";

export default function TemplateVariables({ sources, onSourcesChange, request, readonly, target, onTargetChange, onInsert, canInsert, onCatalog, bodyOnly = false }) {
  const [catalog, setCatalog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [folder, setFolder] = useState("");
  const [search, setSearch] = useState("");
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const abort = new AbortController();
    setLoading(true);
    setError("");
    request("get", "/messaging/templates/variable-sources", undefined, abort.signal)
      .then(({ data }) => {
        if (abort.signal.aborted) return;
        if (!Array.isArray(data.sources) || !data.sources.length) throw new Error("Invalid variable catalog");
        setCatalog(data.sources);
        onCatalog(data.sources);
      })
      .catch(failure => { if (!abort.signal.aborted) setError(errorText(failure)); })
      .finally(() => { if (!abort.signal.aborted) setLoading(false); });
    return () => abort.abort();
  }, [request, onCatalog, revision]);
  const enabled = catalog.filter(source => sources.includes(source.id));
  const selectedFolder = enabled.some(source => source.id === folder) ? folder : enabled[0]?.id || "";
  const current = enabled.find(source => source.id === selectedFolder);
  const fields = (current?.fields || []).filter(field => (field.label + " " + field.key).toLowerCase().includes(search.trim().toLowerCase()));

  return <div className="flex w-full flex-col gap-3" aria-label="Template variables">
    <p className="text-sm">Choose the data sources available to this template. Each message uses records linked to its recipient.</p>
    {loading && <p role="status" className="text-xs text-gray-500">Loading data sources…</p>}
    {error && <div role="alert" className="text-sm text-red-700">{error}<button type="button" className={buttonClass} onClick={() => setRevision(value => value + 1)}>Retry loading sources</button></div>}
    <div className="flex flex-wrap gap-4">{catalog.map(source => <label key={source.id} className="flex items-center gap-2 text-sm">
      <input type="checkbox" disabled={readonly || loading || (sources.includes(source.id) && sources.length === 1)} checked={sources.includes(source.id)}
        onChange={event => onSourcesChange(event.target.checked ? [...sources, source.id] : sources.filter(id => id !== source.id))} />{source.label}
    </label>)}</div>
    {!readonly && !!enabled.length && <>
      <div className="flex flex-col gap-3 md:flex-row">
        <Field label="Variable folder"><select className={fieldClass} value={selectedFolder} onChange={event => { setFolder(event.target.value); setSearch(""); }}>{enabled.map(source => <option key={source.id} value={source.id}>{source.label}</option>)}</select></Field>
        <Field label="Search variables"><input type="search" className={fieldClass} value={search} onChange={event => setSearch(event.target.value)} /></Field>
        <Field label="Insert variable into"><select className={fieldClass} value={bodyOnly ? "body" : target} onChange={event => onTargetChange(event.target.value)}><option value="body">Message</option>{!bodyOnly && <option value="subject">Subject / title</option>}</select></Field>
      </div>
      <p className="text-xs text-gray-600">{current?.description}</p>
      <div className="flex flex-wrap gap-2">{fields.map(field => <button type="button" disabled={!canInsert || loading || !!error} key={field.key} className={buttonClass} title={field.token + " · Example: " + field.example} onClick={() => onInsert(field.token)}>{field.label}</button>)}</div>
      {!fields.length && <p className="text-xs text-gray-500">No variables match this search.</p>}
      {!canInsert && <p className="text-xs text-gray-500">Add a content variant below to insert variables.</p>}
    </>}
  </div>;
}
